module.exports = __webpack_public_path__ + "static/media/NoImage.2018264d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/NoImage.jpg
// module id = 412
// module chunks = 20